import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/logo.svg'


const _hoisted_1 = { class: "bg-orange-600 min-h-screen pt-14 md:pt-20 pb-6 px-2 md:px-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "max-w-lg mx-auto" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-white text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "m-auto",
      src: _imports_0,
      width: "120",
      alt: "logo l'angolo della frutta"
    })
  ])
], -1)
const _hoisted_3 = { class: "bg-white max-w-lg mx-auto p-8 md:p-12 my-10 rounded-lg shadow-2xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-2xl" }, "Autenticazione"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 pt-2 text-sm" }, "Per poter utilizare l'applicazione, inserisci i dati di accesso autorizzati.")
], -1)
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = {
  class: "flex flex-col",
  method: "POST",
  action: "#"
}
const _hoisted_7 = { class: "mb-1 pt-3 rounded" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2 ml-3",
  for: "user"
}, "Utente", -1)
const _hoisted_9 = { class: "mb-8 pt-3 rounded" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2 ml-3",
  for: "pwd"
}, "Password", -1)
const _hoisted_11 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Accedi ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "user",
              id: "user",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event)),
              class: "bg-gray-200 rounded w-full text-gray-700 focus:outline-none border-b-4 border-gray-300 focus:border-purple-600 transition duration-500 px-3 py-2"
            }, null, 512), [
              [_vModelText, _ctx.user]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "pwd",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwd) = $event)),
              class: "bg-gray-200 rounded w-full text-gray-700 focus:outline-none border-b-4 border-gray-300 focus:border-purple-600 transition duration-500 px-3 py-2"
            }, null, 512), [
              [_vModelText, _ctx.pwd]
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["modal-open bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 rounded shadow-lg hover:shadow-xl transition duration-200", { 'opacity-60 cursor-not-allowed': _ctx.sending }]),
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.user && _ctx.pwd && _ctx.accedi()))
          }, [
            (_ctx.sending)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
              : _createCommentVNode("", true),
            _hoisted_15
          ], 2)
        ])
      ])
    ])
  ]))
}